import { render, staticRenderFns } from "./SliceList.vue?vue&type=template&id=615fcc53&scoped=true"
import script from "./SliceList.vue?vue&type=script&lang=js"
export * from "./SliceList.vue?vue&type=script&lang=js"
import style0 from "./SliceList.vue?vue&type=style&index=0&id=615fcc53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fcc53",
  null
  
)

export default component.exports